import { X, Home } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { ChannelNav } from '@/components/feed/ChannelNav';
import { cn } from '@/lib/utils';

interface MobileSidebarProps {
  open: boolean;
  onClose: () => void;
}

export function MobileSidebar({ open, onClose }: MobileSidebarProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />

      {/* Sidebar Panel - slides in from LEFT */}
      <div className="absolute left-0 top-0 bottom-0 w-72 bg-card border-r border-border flex flex-col animate-in slide-in-from-left duration-200">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-border" style={{ background: 'hsl(217 69% 11%)' }}>
          <div className="flex items-center gap-2">
            <img src="/qbn-logo.png" alt="QBN" className="w-8 h-8 rounded-lg" />
            <span className="font-display font-bold text-sm text-white">QBN</span>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-white/70 hover:text-white hover:bg-white/10 transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        {/* Home Link */}
        <div className="px-3 py-3 border-b border-border">
          <NavLink
            to="/home"
            onClick={onClose}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all font-medium',
                isActive
                  ? 'bg-primary/10 text-primary'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              )
            }
          >
            <Home className="h-5 w-5" />
            <span>Home</span>
          </NavLink>
        </div>

        {/* Channels */}
        <div className="flex-1 overflow-y-auto" onClick={onClose}>
          <ChannelNav />
        </div>
      </div>
    </div>
  );
}
